export const AVALIACAO_PPA = 'AVALIACAO_PPA';
export const AVALIACAO_PPA_START = 'AVALIACAO_PPA_START';
export const AVALIACAO_PPA_ERROR = 'AVALIACAO_PPA_ERROR';
export const AVALIACAO_PPA_SUCCESS = 'AVALIACAO_PPA_SUCCESS';
